module.exports = __webpack_public_path__ + "img/contrucao.8adfb983.jpg";